import ApiService from '@/services/ApiService'
import Account, { type ShopRegistration } from '@/models/Account'
import ListRequest from '@/models/requests/ListRequest'
import PaginationModel from '@/models/PaginationModel'

export default class AccountService {
  public static async create(registration: ShopRegistration): Promise<Account> {
    return ApiService.post<Account>(`accounts`, registration)
  }

  public static async delete(id: string): Promise<void> {
    return ApiService.delete<void>(`accounts/${id}`)
  }

  public static async get(id: string): Promise<Account> {
    return ApiService.get<Account>(`accounts/${id}`)
  }

  public static async list(queryParams: ListRequest): Promise<PaginationModel<Account>> {
    // Only shops: an account that books ads but plays no in-store radio has
    // nothing to manage here.
    return ApiService.get<PaginationModel<Account>>(`accounts`, { ...queryParams, instore: 1 })
  }

  public static async update(account: Partial<Account>): Promise<Account> {
    return ApiService.put<Account>(`accounts/${account.id}`, account)
  }
}
